import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { usePrefs, useLabels, useRequestData } from 'wsm-common-data';
import { API } from '../api/services';
import { getDistance } from '../utils/utility';

const Distance = () => {
	const prefs = usePrefs();
	const labels = useLabels();
	const { locale } = useRequestData();
	const { vehicleLat, vehicleLong } = useSelector((state) => state.location);
	const [distance, setDistance] = useState(null);
	const [showDistance, setShowDistance] = useState(
		prefs.showDistanceFromShopper === 'true'
	);
	const [userLat, setUserLat] = useState(null);
	const [userLong, setUserLong] = useState(null);
	const [userZip, setUserZip] = useState(null);

	useEffect(() => {
		if (showDistance) {
			const userPostalCode = window.localStorage.getItem('userLocation');
			if (userPostalCode) {
				const getDistanceFromLS = async () => {
					const result = await API.getDistanceFromLS(
						userPostalCode,
						vehicleLat,
						vehicleLong,
						locale
					);
					setDistance(result.distance);
					setUserZip(userPostalCode);
				};
				getDistanceFromLS();
			} else {
				try {
					const sessionStorageLocation = JSON.parse(
						window.sessionStorage.getItem('session.location')
					);

					setUserLat(sessionStorageLocation?.userLatitude);
					setUserLong(sessionStorageLocation?.userLongitude);
					setUserZip(sessionStorageLocation?.userPostalCode);
				} catch (error) {
					setShowDistance(false);
				}

				setDistance(
					Math.round(
						getDistance(
							userLat,
							userLong,
							vehicleLat,
							vehicleLong,
							locale
						)
					)
				);
			}
		}
	}, [
		showDistance,
		distance,
		userLat,
		userLong,
		vehicleLat,
		vehicleLong,
		locale
	]);

	const getLabeledValue = (label, location) => {
		return labels
			.get(label)
			.replace(/\{\{distance\}\}/, distance)
			.replace(/\{\{location\}\}/, location);
	};

	if (showDistance && distance) {
		return (
			<div>
				<span className="ddc-font-size-xsmall">
					{getLabeledValue('DISTANCE_FROM_LOCATION', userZip)}
				</span>
			</div>
		);
	} else {
		return null;
	}
};

export default Distance;
